import { CardContent } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";

interface InnoventureTestBodyProps {
  description: string;
  welcomeMessage?: string;
}

export function InnoventureTestBody({
  description,
  welcomeMessage,
}: InnoventureTestBodyProps) {
  return (
    <CardContent className="p-8 space-y-6">
      <div>
        <h2 className="text-xl font-semibold mb-3">About This Test</h2>
        <div 
          className="text-muted-foreground leading-relaxed whitespace-pre-wrap"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>

      {welcomeMessage && (
        <Alert className="border-primary/20 bg-primary/5">
          <Info className="h-4 w-4 text-primary" />
          <AlertDescription className="text-sm leading-relaxed whitespace-pre-wrap">
            <div dangerouslySetInnerHTML={{ __html: welcomeMessage }} />
          </AlertDescription>
        </Alert>
      )}
    </CardContent>
  );
}
